// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"ccb8af23","498":"6addbe94","703":"17f936cb"}[chunkId] + ".chunk.js";
};